var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-container clear"},_vm._l((_vm.rocketComps.tree[0]
      .children[3].children),function(i,index){return _c('DashboardItem',{key:index+i.t+i.w+i.d,attrs:{"index":index,"rocketGlobal":_vm.rocketGlobal,"i":i,"dragIndex":_vm.dragIndex},on:{"dragStart":_vm.dragStart}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }